import { en, overrides } from "../messages/runtime.ts";
import { BASE_LOCALE, locales, type Locale } from "./site";

export type Messages = { [Key in keyof typeof en]: string };

// Each non-base locale is the full English catalog with its own overrides layered
// on top, so a missing key transparently falls back to English.
export const messages = Object.fromEntries(
  locales.map((locale) => [
    locale,
    locale === BASE_LOCALE ? en : { ...en, ...(overrides[locale] ?? {}) },
  ]),
) as Record<Locale, Messages>;

export function getMessages(locale: Locale): Messages {
  return messages[locale];
}
